import request from "@/utils/request";
// banner列表
const getBannerList = (params) =>
  request.post("/laiHi/web/index/pageBanner", params);
// 添加/修改banner
const setBanner = (params) =>
  request.post("/laiHi/web/index/addModifyBanner", params);
// 修改banner 状态
const editBannerStatus = (params) =>
  request.post("/laiHi/web/index/modifyBannerStatus", params);
// 删除banner
const deleteBanner = (params) =>
  request.post("/laiHi/web/index/deleteBanner", params);

// 资讯列表
const getNewsList = (params) =>
  request.post("/laiHi/web/index/newsList", params);
// 通过id获取资讯详情
const getNewDetails = (params) =>
  request.post("/laiHi/web/index/newsDetail", params);
// 添加编辑资讯
const setNews = (params) =>
  request.post("/laiHi/web/index/addModifyNews", params);
// 修改资讯状态
const editNewsStatus = (params) =>
  request.post("/laiHi/web/index/modifyNewsStatus", params);
// 删除资讯
const deleteNews = (params) =>
  request.post("/laiHi/web/index/deleteNews", params);

// 消息公告列表
const getInfoList = (params) =>
  request.post("/laiHi/web/index/noticeList", params);
// 新增修改公告
const setInfo = (params) =>
  request.post("/laiHi/web/index/addModifyNotice", params);
// 修改消息公告状态
const editInfoStatus = (params) =>
  request.post("/laiHi/web/index/modifyNoticeStatus", params);
// 查看消息公告详情
const getInfoDetais = (params) =>
  request.post("/laiHi/web/index/noticeDetail", params);
// 删除消息公告
const deleteInfo = (params) =>
  request.post("/laiHi/web/index/deleteNotice", params);
export {
  getBannerList,
  setBanner,
  editBannerStatus,
  deleteBanner,
  getNewsList,
  setNews,
  editNewsStatus,
  deleteNews,
  getInfoList,
  getNewDetails,
  setInfo,
  editInfoStatus,
  getInfoDetais,
  deleteInfo,
};
